import React from 'react';

import { useTranslation } from '@splitfiesta/i18n';
import { Alert } from '@splitfiesta/ui';

import { ErrorState } from '@/types/error.types';

import { getErrorMessage } from '@/utils/errorHandler';

interface EnhancedErrorDisplayProps {
  error: ErrorState;
  type?: 'error' | 'warning';
  className?: string;
  onDismiss?: () => void;
}

export function EnhancedErrorDisplay({
  error,
  type = 'error',
  className,
  onDismiss,
}: EnhancedErrorDisplayProps) {
  const { t } = useTranslation();

  if (!error) return null;

  const message = getErrorMessage(error, t);

  return (
    <Alert
      type={type}
      message={message}
      className={className}
      onDismiss={onDismiss}
      dismissLabel={t('common:actions.close')}
      data-testid="alert"
    />
  );
}

// Convenience component for inline error display
export function InlineError({ error }: { error: ErrorState }) {
  return <EnhancedErrorDisplay error={error} className="mb-4" />;
}

// Convenience component for form errors
export function FormError({ error }: { error: ErrorState }) {
  return <EnhancedErrorDisplay error={error} className="mb-6" />;
}
